import { render, staticRenderFns } from "./LeftFooter.vue?vue&type=template&id=33edc648&scoped=true&"
import script from "./LeftFooter.vue?vue&type=script&lang=js&"
export * from "./LeftFooter.vue?vue&type=script&lang=js&"
import style0 from "./LeftFooter.vue?vue&type=style&index=0&id=33edc648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edc648",
  null
  
)

export default component.exports